const PRELOAD_RELOAD_STORAGE_KEY = "orizom:vite-preload-reload";
const PRELOAD_RELOAD_GUARD_MS = 5_000;

const ASSET_LOAD_ERROR_PATTERNS = [
  /chunkloaderror/i,
  /loading (?:css )?chunk [\w-]+ failed/i,
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /unable to preload css/i,
  /failed to load module script/i,
];

let reloadPending = false;

const readLastReloadAt = () => {
  try {
    return Number(window.sessionStorage.getItem(PRELOAD_RELOAD_STORAGE_KEY)) || 0;
  } catch {
    return 0;
  }
};

const storeReloadAt = (timestamp) => {
  try {
    window.sessionStorage.setItem(
      PRELOAD_RELOAD_STORAGE_KEY,
      String(timestamp)
    );
  } catch {}
};

const clearReloadGuard = (timestamp) => {
  window.setTimeout(() => {
    try {
      const storedTimestamp = Number(
        window.sessionStorage.getItem(PRELOAD_RELOAD_STORAGE_KEY)
      );
      if (storedTimestamp === timestamp) {
        window.sessionStorage.removeItem(PRELOAD_RELOAD_STORAGE_KEY);
      }
    } catch {}
  }, PRELOAD_RELOAD_GUARD_MS);
};

const getErrorText = (error) =>
  [error?.name, error?.message, error?.cause?.name, error?.cause?.message]
    .filter(Boolean)
    .join(" ");

export const isFrontendAssetLoadError = (error) => {
  const errorText = getErrorText(error);
  return ASSET_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(errorText));
};

export const requestFrontendReload = () => {
  if (typeof window === "undefined") return false;
  if (reloadPending) return true;

  const now = Date.now();
  const lastReloadAt = readLastReloadAt();
  const elapsed = lastReloadAt ? now - lastReloadAt : PRELOAD_RELOAD_GUARD_MS;
  const delay = Math.max(PRELOAD_RELOAD_GUARD_MS - elapsed, 0);

  reloadPending = true;

  window.setTimeout(() => {
    const reloadAt = Date.now();
    storeReloadAt(reloadAt);
    window.location.reload();
  }, delay);

  return true;
};

export const installVitePreloadRecovery = () => {
  if (typeof window === "undefined") return;

  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    requestFrontendReload();
  });

  const lastReloadAt = readLastReloadAt();
  if (lastReloadAt) clearReloadGuard(lastReloadAt);
};
